export default __webpack_public_path__ + "static/media/bg-list-1.dc2649e8.svg";